import "@capacitor/core"
import "./index.css"
import "~brandcss"

import App from "./App.vue"
import router from "./router/router"

import { VueQueryPlugin } from "@tanstack/vue-query"
import { queryClient } from "@/queryClient"

import * as Sentry from "@sentry/vue"
import { makeNativeTransport } from "./utils/ingenicoNativeSentryTransport"

const app = createApp(App)

if (import.meta.env.VITE_SENTRY_ENABLED === "true") {
  Sentry.init({
    app,
    dsn:
      import.meta.env.VITE_ORGANIZATION === "boipa"
        ? "https://f30c4643b1816ff28b381021f85e746d@o4507266038693888.ingest.de.sentry.io/4508919918690384"
        : "https://2cc1045e1ff9a4f5215f917430272603@o4507266038693888.ingest.de.sentry.io/4507777544421456",
    integrations: [
      Sentry.extraErrorDataIntegration({ depth: 5 }),
    ],
    environment: import.meta.env.VITE_ENVIRONMENT,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    transport:
      import.meta.env.VITE_PLATFORM === "ingenicoNerpay"
        ? makeNativeTransport
        : undefined,
    attachStacktrace: true,
  })

  Sentry.setTag(
    "device.platform",
    import.meta.env.VITE_PLATFORM
  )
}

app.use(router)

app.use(VueQueryPlugin, { queryClient })

app.mount("#app")

export default {
  app,
}
